import type { ReactNode } from 'react'
import { useCurrentUser } from '../../features/auth/hooks'
import type { PlatformRole } from '../../features/auth/api'

interface RoleGateProps {
  allow: PlatformRole[]
  fallback?: ReactNode
  children: ReactNode
}

export function RoleGate({ allow, fallback = null, children }: RoleGateProps) {
  const { data: user } = useCurrentUser()
  if (!user) return <>{fallback}</>
  return allow.includes(user.platform_role) ? <>{children}</> : <>{fallback}</>
}

// eslint-disable-next-line react-refresh/only-export-components
export function isBon8Staff(role: PlatformRole | undefined): boolean {
  return role === 'bon8_admin' || role === 'bon8_staff'
}
